<template lang="pug">
v-text-field(
  v-bind="$attrs"
  v-on="$listeners"
  :rules="hostRules"
  label='Azure App Client Id'
  data-track="clientId"
  dense clearable outlined required)

</template>

<script lang="ts">
import isConvertibleToNotBlankString from '@/utils/isConvertibleToNotBlankString';
import { Vue, Component } from 'vue-property-decorator';

@Component
export default class InputHost extends Vue {
  hostRules = [(v: string) => isConvertibleToNotBlankString(v) || 'Client Id is required'];
}
</script>
